"use strict";

var _react = _interopRequireDefault(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var _default = function _default(a) {
  var b = a.field,
      c = a.pages,
      d = a.nextStep,
      f = a.prevStep,
      g = a.isNextDisabled,
      h = a.styledComponents,
      i = b.id,
      e = b.type,
      j = b.label,
      k = b.placeholder,
      l = b.isRequired,
      m = b.maxLength,
      n = b.description,
      o = b.descriptionPlacement,
      p = b.labelPlacement,
      q = b.cssClass,
      r = b.width,
      s = b.nextButton,
      t = b.previousButton,
      u = b.pageNumber,
      v = h || !1,
      w = v.Box,
      x = void 0 === w ? "div" : w,
      y = v.Button,
      z = void 0 === y ? "button" : y;
  return _react["default"].createElement(x, {
    className: "form-field"
  }, 1 < u - 1 && _react["default"].createElement(z, {
    className: "prev",
    mr: 10,
    onClick: function onClick(a) {
      return f(a);
    }
  }, t.text), u <= c && _react["default"].createElement(z, {
    className: "next",
    onClick: function onClick(a) {
      return d(a);
    },
    mt: 20,
    disabled: g
  }, s.text));
};

exports["default"] = _default;